import React from "react";
import { RouterProvider } from "@tanstack/react-router";
import { router } from "./router";
// import initSmoothScroll from "./utils/smoothScroll";

function App() {
  // React.useEffect(() => {
  //   initSmoothScroll();
  // }, []);

  // check if there exist a key products in local storage
  if (!localStorage.getItem("products")) {
    localStorage.setItem("products", JSON.stringify([]));
  }

  return <RouterProvider router={router} />;
}

export default App;

